<template>
    <div class="ball-bg" v-if="project!=null" style="user-select: none;">
        <div v-if="project.project_state === 1 || project.paid">
            <div style="display: flex;flex-direction: row;justify-content: center;align-items: flex-start; margin: 30px 15px;">
                <van-image style="margin: 0 10px;min-width: 24px" width="24" height="24" :src="images.ic_home"
                           @click="go_home"></van-image>
                <div class="project-title">
                  <span>{{projectTitle()}}</span>
                </div>
            </div>

            <div class="project-info">
                <div>{{project.create_time}}</div>
                <div>类别：<span :class="[project.project_category==='篮球'?'basketball':'football']">{{project.project_category}}</span></div>
                <van-image v-if="project.project_state===2" style="position: absolute; right: 10px;z-index: 100;"
                           width="56px" height="56px" :src="images.game_over"></van-image>
            </div>
            <div class="buy-content" style="background-color: rgba(227, 158, 53, 0.25);margin: 15px;color: #2e2e2e">
                <!--                <van-button type="info" size="small">免责声明</van-button>-->
                <div style="margin-top:15px">免责声明</div>
                <div class="buy-content-des">本站仅提供网络收集各大著名足球、篮球解析文章，非购彩、非合买、非跟单平台，内容仅供浏览和参考{{westore.state.user.userCode}}，并非投注建议，据此购彩风险自担。相关部门已暂停网络购彩，一切互联网购彩皆为非法，请各位彩民朋友到线下合法彩票销售点购彩。</div>
            </div>
            <div class="project-content">
                <div  v-for="(item, index) in project.articles" :key="item.article.article_id">
                    <div class=" article-content">
                        <div class="weball-font-14" style="display: flex;justify-content: space-between;font-weight: bold;padding: 15px">
                    <span class="van-ellipsis " style="max-width:calc(100px);text-decoration:underline"
                          @click="go_writer(item.article.writer.writer_id)">{{item.article.writer.writer_name}}</span>
                            <div class="van-ellipsis"
                                 style="max-width:calc(100vw - 150px);text-align: right;margin-left: 10px">
                                {{item.article.article_title}}
                            </div>
                        </div>
                        <div :id="item.article.article_id">
                        </div>
                    </div>
                </div>
<!--                <watermark :type="waterOption.type" :color="waterOption.color" :logo="waterOption.logo" :texts="waterOption.texts"-->
<!--                           :count="waterOption.count" :size="waterOption.size"></watermark>-->
                <div class="buy-content" v-if="westore.state.user.userInfo == null || !project.paid">
                    <van-button type="info" size="small" @click="alertMenu">查看内容</van-button>
                    <!--<div class="buy-content-des">包月会员可无限看平台所有方案；有效期从支付日期开始，累计31天；续费会员有效期从上一个周期结束后再累计加31天</div>-->
                    <!--<van-action-sheet :round="false" v-model="menu.show" :actions="menu.actions" cancel-text="取消"-->
                    <!--@select="onSelect">-->
                    <!--</van-action-sheet>-->
                    <van-action-sheet :round="false" v-model="menu.show">
                        <div class="weball-action-wrap" v-if="westore.getters.logined">
                            <div v-if="browser.browser().wechat">
                                <div @click="onSelect({project_id: project.project_id, type: 1, way:'quanpay'})" class="van-hairline--top weball-action">
                                    <div>
                                        <div v-if="westore.state.user.userInfo" style="font-size: 12px;color:#999;line-height: 18px;margin-bottom: 5px">（点券余额：{{westore.state.user.userInfo.balance}}）</div>
                                        <div>点券支付<span>{{project.project_price}}</span>点</div>
                                    </div>
                                </div>
                                <div @click="onSelect({project_id: project.project_id, type: 1, way:'wepay'})" class="van-hairline--top weball-action">
                                    <div>微信支付<span>{{project.project_price}}</span>元</div>
                                </div>
<!--                                <div @click="onSelect({project_id: project.project_id, type: 1, way:'adapay'})" class="van-hairline&#45;&#45;top weball-action">-->
<!--                                  <div>汇付支付<span>{{project.project_price}}</span>元</div>-->
<!--                                </div>-->
                                <div v-if="westore.state.user.userInfo != null" @click="onAlipay({project_id: project.project_id, type: 1, way:'alipay'})" class="van-hairline--top weball-action">
                                    <div>支付宝支付<span>{{project.project_price}}</span>元</div>
                                </div>
                                <!--<div @click="onSelect({project_id: project.project_id, type: 2})" class="weball-action">-->
                                <!--成为月会员<span>{{westore.state.user.userInfo.vip_price}}</span>元-->
                                <!--</div>-->
                            </div>
                            <div v-else>
                                <div v-if="westore.state.user.userInfo != null" @click="onSelect({project_id: project.project_id, type: 1, way:'quanpay'})" class="van-hairline--top weball-action">
                                    <div>
                                        <div v-if="westore.state.user.userInfo" style="font-size: 12px;color:#999;line-height: 18px;margin-bottom: 5px">（点券余额：{{westore.state.user.userInfo.balance}}）</div>
                                        <div>点券支付<span>{{project.project_price}}</span>点</div>
                                    </div>
                                </div>
                                <div @click="onSelect({project_id: project.project_id, type: 1, way:'alipay'})" class="van-hairline--top weball-action">
                                    <div>支付宝支付<span>{{project.project_price}}</span>元</div>
                                </div>
<!--                                <div @click="onWepay({project_id: project.project_id, type: 1, way:'alipay'})" class="van-hairline&#45;&#45;top weball-action">-->
<!--                                    <div>微信支付<span>{{project.project_price}}</span>元</div>-->
<!--                                </div>-->
                            </div>
                            <div style="background-color: #f4f4f4;height: 10px"></div>
                            <div @click="menu.show = false" class="weball-action">取消</div>
                        </div>
                    </van-action-sheet>
                </div>
                <div class="buy-content" style="background-color: #f0f0f0;margin: 15px;padding: 15px">
                    <div style="color: #2e2e2e;font-size: 18px;font-weight: bold">怎么查看大神历史战绩</div>
                    <div style="margin-top: 15px;font-size: 16px">
<!--                        <span style="color: #ee0a24;" @click="download_app">点击下载App</span>-->
                        <span style="color: #ee0a24;">联系客服获取大神历史战绩</span>
                    </div>
                </div>
            </div>
            <div v-if="relatedProjects != null && relatedProjects.length>0" >
                <div class="title">推荐分析</div>
                <div class="van-hairline--bottom van-hairline--top" >
                    <project-item :project="{
                    refresh:true,
                    articles:item.project.articles,
                    project_id:item.project_id,
                    is_multi:item.project.articles.length>1,
                    avatar:item.project.articles[0].article.writer.avatar.web_path,
                    category:item.project.project_category,
                    title:item.project.project_title,
                    content_visible:item.project.articles[0].article.article_content_visible,
                    price:item.project.project_price,
                    borwser_num:item.project.project_borwser_num,
                    state:item.project.project_state
                  }" v-for="(item, index) in  relatedProjects" :key="item.project_id">
                    </project-item>
                </div>
            </div>
            <van-popup v-model="alipay.popup_show"  position="top" :style="{ height: '50%' }">
            </van-popup>
            <anti-lost-dialog ref="antilost"></anti-lost-dialog>
        </div>
        <div v-else style="color: #ee0a24;font-size: 18px;text-align: center;margin-top: 10%">
            已结束
        </div>
    </div>
</template>
<script>
    import CanvasWater from '@/plugins/warterMark'
    import DrawUtil from './drawUtil'
    import game_over from '@/assets/game_over.png'
    import ic_home from '@/assets/ic_home.png'
    import Watermark from '@/components/kxj-watermark.vue'
    import TextIcon from '@/components/TextIcon'
    import ProjectItem from '@/views/components/ProjectItem'
    import AntiLostDialog from "@/views/components/AntiLostDialog";
    export default {
        props: ['id'],
        name: 'project',
        components:{
            Watermark,
            TextIcon,
            ProjectItem,
            AntiLostDialog
        },
        filters:{

        },
        data() {
            return {
                alipay:{
                  popup_show:false
                },
                waterOption: {
                    type: 'fixation', //fixation,follow
                    texts: [
                        this.westore.state.app.systemInfo.waterMark.firstLine,
                        this.westore.state.app.systemInfo.waterMark.secondLine,
                        this.westore.state.app.systemInfo.waterMark.thirdLine,
                    ],
                    logo:require('../../assets/water.png') ,
                    count: 50,
                    opacity: 0.5,
                    size: 1,
                    height: "130%",
                    color: '#2b85e4',
                    rotate: -35
                },
                watermarkInterval: 0,
                images: {
                    game_over: game_over,
                    ic_home: ic_home,
                },
                user: null,
                app_name:'',
                menu: {
                    show: false,
                    actions: []
                },
                project_id: this.$route.params.project_id,
                project: null,
                relatedProjects: null,
                activeNames: []
            }
        },
        // beforeRouteUpdate (to, from, next) {
        //     this.project_id = to.params.project_id
        //     this.getData(this.project_id);
        //     this.getRelatedProjects(this.project_id)
        //     next()
        // },
        created() {
            this.app_name = this.weutil.hasProperty(this.westore.state.app.systemInfo, 'app_name') ? this.westore.state.app.systemInfo.app_name : '微球推球'
            // this.startWaterMark();
            this.getData(this.project_id);
            this.getRelatedProjects(this.project_id)
        },
        mounted() {
            this.getUserInfo()
        },
        destroyed() {
            // CanvasWater.remove()
            // clearInterval(this.watermarkInterval)
        },
        methods: {
            projectTitle(){
              if(!this.project)
              {
                return ''
              }
              if(!this.project.project_label)
              {
                return this.project.project_title
              }

              if((this.project.project_title+"").indexOf(this.project.project_label) !== -1){

                return this.project.project_title
              }
              if(['）',')','】',']'].indexOf(this.project.project_title.slice(-1)) !== -1){
                return this.project.project_title
              }
              return this.project.project_title + '（' + this.project.project_label+'）'
            },
            download_app:function () {
                window.location.href = this.westore.state.app.systemInfo.updateInfo.index
            },
            getUserInfo:function(){
                let that = this;
                this.westore.dispatch('getUserInfo').then(user => {
                }).catch((res) => {
                    that.westore.commit('setToken', '')
                })
            },
            setWaterMark: function () {
                this.app_name = this.weutil.hasProperty(this.westore.state.app.systemInfo, 'app_name') ? this.westore.state.app.systemInfo.app_name : '微球推球'
                CanvasWater.set(this.app_name)
            },
            startWaterMark: function () {
                let that = this;
                this.watermarkInterval = setInterval(function () {
                    that.setWaterMark()
                }, 100)
            },
            go_detail: function (ID) {
                this.$router.push({name: this.werouter.project.name, params: {project_id: ID}})
                location.reload()
            },
            go_home: function () {
                this.$router.push({name: this.werouter.index.name})
            },
            go_writer: function (writer_id) {
                this.$router.push({name: this.werouter.authordetail.name, params: {writer_id: writer_id}})
            },
            alertMenu: function () {
                if (this.westore.getters.logined) {
                    if (this.menu.actions.length === 0) {
                        this.menu.actions = [
                            {
                                className: 'single-pay',
                                name: '单篇查看',
                                subname: this.project.project_price + ' 支付本分析',
                                data: {project_id: this.project.project_id, type: 1}
                            },
                            // {
                            //     name: '包月查看',
                            //     subname: this.westore.state.user.userInfo.vip_price,
                            //     data: {project_id: this.project.project_id, type: 2}
                            // },
                        ]
                    }
                    this.menu.show = true;
                }
                else {
                    this.$router.push({
                        name: this.werouter.login.name,
                        query: {redirect_name:this.werouter.index.name, project_id: this.project.project_id}
                    })
                }
            },
            onWepay:function(data){
                this.$refs.antilost.show()
                this.menu.show = false;
            },
            onAlipay:function(data){
                this.$router.push({
                    name: this.werouter.alipay.name,
                    query: {
                        uid: this.westore.state.user.userInfo.uid,
                        project_id: this.project.project_id,
                        app_id:this.westore.state.app.app_id,
                        guide:true
                    }
                })
            },
            onSelect: function (data) {
                this.menu.show = false;
                if (this.westore.getters.isbind) {
                    this.buy(data);
                }
                else {
                    this.$dialog.confirm({
                        title: '防止失联',
                        message: '绑定手机号，在各浏览器可用手机号登录！'
                    }).then((res) => {
                        if (res === 'confirm') {
                            this.$router.push({name: this.werouter.bindphone.name})
                        }
                        else {
                            this.buy(data);
                        }
                    }).catch(() => {
                    });

                }
            },
            getData: function (project_id) {
                let that = this;
                this.weapi.request({
                    url: 'project_detail',
                    method: 'get',
                    params: {'project_id': project_id},
                }).then(res => {
                    if (res.data.code === '200') {
                        that.project = res.data.data;
                        if( that.project.project_state === 1 ||  that.project.paid){
                            this.weutil.forEach(that.project.articles, function (item) {
                                if (item.article.article_content_payed !== undefined) {
                                    that.activeNames.push(item.article.article_id);
                                }
                                setTimeout(function () {
                                    DrawUtil.drawContent(item.article_id, item.article, that.app_name)
                                    // DrawUtil.drawPayedContent(item.article_id, item.article.article_content_payed===undefined?'暂未购买，点击查看方案继续':item.article.article_content_payed)
                                }, 1)
                            })
                        }

                    }
                    else {
                    }
                }).catch(function (error) {
                    console.log(error)
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
            buy: function (data) {
                let that = this;
                if (data.type === 1) {//支付方案
                    if(data.way === 'wepay'){
                        this.westore.dispatch('payProject', {
                            app_id: this.westore.state.app.app_id,
                            project_id: this.project_id
                        }).then(res => {
                            that.$toast("支付成功！");
                            that.getData(that.project_id);
                        }).catch((res) => {
                            that.$toast(res);
                        })
                    }
                    else if(data.way === 'adapay'){
                      this.adapay()
                    }
                    else if(data.way === 'quanpay'){
                        this.quanpay()
                    }
                    else if(data.way === 'alipay'){
                        this.weapi.request({
                            url: 'pay/alipay/project',
                            method: 'get',
                            params: {
                                app_id: this.westore.state.app.app_id,
                                project_id: this.project_id
                            },
                        }).then(res => {
                            if (res.status === 200) {
                                const div = document.createElement('div')
                                /* 此处form就是后台返回接收到的数据 */
                                div.innerHTML = res.data
                                document.body.appendChild(div)
                                document.forms[0].submit()
                            }
                            else if(res.status === 202){
                                that.$toast(res.data);
                            }
                            else {

                            }
                        }).catch(function (error) {
                            console.log(error)
                            that.$toast('支付错误，请联系客服！');
                        }).finally(function (response) {
                        })

                    }
                }
                else if (data.type === 2) {//vip
                    this.westore.dispatch('payVip', {app_id: this.westore.state.app.app_id}).then(res => {
                        that.$toast("支付成功！");
                        that.getData(that.project_id);
                    }).catch((res) => {
                        that.$toast(res);
                    })
                }
            },
            adapay:function(){
              this.weapi.request({
                url: 'pay/adapay/project',
                method: 'get',
                params: {
                  app_id: this.westore.state.app.app_id,
                  project_id: this.project_id
                },
              }).then(res => {
                if (res.data.code === '200') {
                  let order = res.data.data
                  console.log(res)
                }
                else {
                  this.$toast(res.data.message);
                }
              }).catch(function (error) {
                console.log(error)
                this.$toast('支付错误，请联系客服！');
              }.bind(this)).finally(function (response) {
              })
            },
            quanpay:function(){
                if(Number(this.westore.state.user.userInfo.balance) < Number(this.project.project_price)){
                    this.$dialog.confirm({
                        messageAlign:"center",
                        title:"点券余额不足",
                        message:`<div>您的点券余额不足，是否前往充值？</div>`,
                    }).then(() => {
                        this.$router.push({name: this.werouter.recharge.name})
                    }).catch(() => {
                    });
                    return;
                }

                this.weapi.request({
                    url: 'pay/quanpay/project',
                    method: 'get',
                    params: {
                        app_id: this.westore.state.app.app_id,
                        project_id: this.project_id
                    },
                }).then(res => {
                    if (res.data.code === '200') {
                        let order = res.data.data
                        this.$dialog.confirm({
                            messageAlign:"left",
                            title:"支付确认",
                            message:`<div>是否用【<span style="color: red">${this.project.project_price}</span>】点券查看内容【${this.project.project_title}】？</div>`,
                        }).then(() => {
                            this.quanpay_notify(order.id)
                        }).catch(() => {
                        });

                    }
                    else {
                        this.$toast(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error)
                    this.$toast('支付错误，请联系客服！');
                }.bind(this)).finally(function (response) {
                })
            },
            quanpay_notify:function(quanorder_id){
                this.weapi.request({
                    url: 'pay/quanpay/projectNotify',
                    method: 'post',
                    params: {
                        quanorder_id: quanorder_id
                    },
                }).then(res => {
                    if (res.data.code === '200') {
                        this.getUserInfo()
                        this.$toast("支付成功！");
                        this.getData(this.project_id);
                    }
                    else {
                        this.$toast(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error)
                    this.$toast('支付错误，请联系客服！');
                }.bind(this)).finally(function (response) {
                })
            },
            getRelatedProjects: function (project_id) {
                let that = this;
                this.weapi.request({
                    url: 'projects_related',
                    method: 'get',
                    params: {'project_id': project_id},
                }).then(res => {
                    if (res.data.code === '200') {
                        that.relatedProjects = res.data.data;
                    }
                    else {
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            }
        }
    }

</script>
<style>
    .title {
        text-align: center;
        font-weight: 600;
        color: #333;
        font-size: 16px;
        padding: 15px 10px 10px 10px;
    }

    .home-btn {

    }

    .project-title {
        /*text-align: center;*/
        color: #333;
        font-size: 15px;
        font-weight: bold;
    }

    .project-info {
        position: relative;
        margin: 15px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        color: #999;
        font-size: 14px;
    }

    .project-info div {
        margin: 0 5px;
    }

    .project-info .football {
        color: #07c160;
    }
    .project-info .basketball {
      color: #ff976a;
    }

    .project-content {
        /*padding: 0 15px;*/
    }

    .buy-content {
        margin: 15px 0;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .buy-content-des {
        font-size: 13px;
        line-height: 20px;
        margin: 15px;
        text-align: justify;
    }

    .label-class {
        margin: 10px 0;
        font-size: 15px;
        color: #333;
        font-weight: bold;
    }

    .weball-action-wrap {
        z-index: 10000;
        background-color: #fff;
    }

    .weball-action {
        padding: 15px 0;
        text-align: center;
        font-size: 14px;
    }

    .weball-action span {
        margin: 0 4px;
        color: #1aad19;
        font-weight: bold;
    }

    .ball-bg {
    }
    .article-content{
        margin: 15px;
        border-radius: 8px;
        background-color: #f4f4f4;
    }
    .tongji-wrap{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        font-size: 14px;
        margin-right: 20px;
    }
</style>
